import { styled } from '@mui/material/styles';
import { Box, Card, DialogContent, Stack, Paper, DialogActions, Link, Button, DialogTitle } from '@mui/material';
import { theme } from '../../theme';

export const TileContainer = styled(Box)(() => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: '16px',
    marginTop: '16px',
    width: '100%',
}));

export const StyledTile = styled(Card)(({ theme }) => ({
    width: 200,
    height: 200,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    '&:hover': {
        backgroundColor: theme.palette.grey[200],
    },
}));

export const StyledDialogContent = styled(DialogContent)({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: "24px",
});

export const StyledSwitchContainer = styled(Stack)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
});

export const CreatorContainer = styled(Paper)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    width: '95%',
    transition: 'box-shadow 0.3s ease',
    '&:hover': {
        boxShadow: theme.shadows[4],
    },
}));

export const TypeSelectContainer = styled(Box)(({ theme }) => ({
    flex: 1,
    minWidth: 200,

}));

export const CreateButtonContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    flexDirection: 'column',
    flex: 1,
    height: '100%',
}));

export const ErrorMessage = styled(Box)(({ theme }) => ({
    color: theme.palette.error.main,
    fontSize: theme.typography.body2.fontSize,
    marginTop: theme.spacing(1),
}));

export const ServiceModulesWrapper = styled(Box)(({ theme }) => ({
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[3],
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
}));

export const StyledContainerHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
}));

export const StyledDialogActions = styled(DialogActions)({
    position: 'sticky',
    bottom: 0,
    zIndex: 10,
    backgroundColor: 'inherit',
    borderTop: '1px solid #ddd',
    display: "flex",
    justifyContent: "space-between",
    padding: "8px 16px",
    gap: "8px",
    flexWrap: "wrap",
    marginTop: 'auto',
});

export const ButtonGroupRight = styled(Stack)({
    display: "flex",
    flexDirection: "row",
    gap: "8px",
});

export const BreadcrumbWrapper = styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    '& .MuiBreadcrumbs-ol': {
          alignItems: 'center',
    },
}));

export const CrumbLink = styled(Link, {
    shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'none',
    fontWeight: active ? 700 : 400,
    fontSize: '1rem',
    maxWidth: 200,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

export const QuickCreatePanel = styled(Paper)(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[3],
    backgroundColor: theme.palette.background.paper,
    minWidth: 300,
}));

export const QuickCreateItem = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 70,
    cursor: 'pointer',
    transition: 'transform 0.15s ease-in-out',
    '&:hover': {
        transform: 'scale(1.1)',
    },
}));

export const StyledAddButton = styled(Button)(({ theme }) => ({
    minWidth: 0,
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    padding: 0,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',

    '& .MuiButton-startIcon': {
        color: theme.palette.primary.main,
        fontSize: '24px',
        margin: 0,
        padding: 0,
    },

    '&:hover': {
        backgroundColor: theme.palette.action.hover,
    },
}));

export const StickyDialogTitle = styled(DialogTitle)(({ theme }) => ({
    position: 'sticky',
    top: 0,
    zIndex: 10,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
}));
